<template>
  <div :class="$style.container">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FormWrapper',
};
</script>

<style module>
.container {
  display: grid;
  grid-gap: var(--jc-spacer);
}
</style>
